import axios from "axios";

export const getSearchedBuses = async (params, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/bus_search.php?boarding_id=${params.boarding_id}&drop_id=${params.drop_id}&trip_date=${params.trip_date}&sort=${params.sort}&pickupfilter=${params.pickupfilter}&dropfilter=${params.dropfilter}&bustype=${params.bustype}&operatorlist=${params.operatorlist}&facilitylist=${params.facilitylist}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setLoading(false);
    return response?.data;
  } catch (error) {
    console.log("getting search buses error....", error);
    setLoading(false);
    return error;
  }
};

export const getBusLayout = async (params, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/bus_layout.php?bus_id=${params.bus_id}&trip_date=${params.trip_date}&uid=${params.uid}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setLoading(false);
    return response?.data;
  } catch (error) {
    console.log("getting bus layout error...", error);
    setLoading(false);
    return error;
  }
};

export const getPOIListDetail = async (id, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/city_poi_details.php?id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setLoading(false);
    return response?.data;
  } catch (error) {
    console.log("getting poi list details error....", error);
    setLoading(false);
    return error;
  }
};

export const getCityDetail = async (id, setLoading) => {
  setLoading(true);
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/city_details.php?id=${id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setLoading(false);
    return response?.data;
  } catch (error) {
    console.log("getting poi list details error....", error);
    setLoading(false);
    return error;
  }
};
